import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ProjectsComponent } from './projects.component';
import { ProjectDetailsComponent } from './project-details/project-details.component';
import { ProductProjectDetailsComponent } from './product-details/product-project-details/product-project-details.component';

const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    component: ProjectsComponent,
  },
  {
    path: 'projects-setting/:id',
    component: ProjectDetailsComponent,
    loadChildren: () =>
      import('./project-details/project-details-module').then(m => m.ProjectDetailsModule),
  },
  {
    path: 'product-configuration/:id',
    component: ProductProjectDetailsComponent,
    loadChildren: () =>
      import('./product-details/product-details.module').then(m => m.ProductDetailsModule),
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ProjectsRoutingModule {}
